<template>
   <div class="card">
      <div class="card-body">
         <h5 class="card-title mb-2 limitador">Serviço</h5>
         <div class="d-flex flex-column">
            <div class="mb-2">
               <span class="fw-bold">Horas Cumpridas: </span>
               <span>{{ horasCumpridas.horas.toString().padStart(2, '0') }}:{{ horasCumpridas.minutos.toString().padStart(2, '0') }}h</span>
               de
               <span>{{ totalHoras.horas.toString().padStart(2, '0') }}:{{ totalHoras.minutos.toString().padStart(2, '0') }}h</span>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import Swal from 'sweetalert2'
import { mapState } from 'vuex'

export default {
	name: 'Servico',
   props: ['servico', 'index', 'view'],
   data: function () {
      return {
         horasCumpridas: {
            horas: Math.floor(this.servico.totalHorasCumpridas / 60),
            minutos: this.servico.totalHorasCumpridas % 60
         },
         totalHoras: {
            horas: Math.floor(this.servico.totalHoras / 60),
            minutos: this.servico.totalHoras % 60
         },
      }
   },
   computed: {
      ... mapState({
         dadosUsuario: state => state.dadosUsuario,
         tokenSessao: state => state.tokenSessao,
         urlRest: state => state.urlRest
      })
   },
   methods: {
      imageError : function (e) {
         this.$store.dispatch('imageError', e)
      },
      feedback : function () {
         if (this.dadosUsuario.usuarioEntidade || this.servico.feedback) {
            this.$emit('feedback', this.servico)
         }
      },
      editar : function () {
         this.$emit('editar', this.servico)
      },
      excluir : function (id) {
         let ref = this;

         Swal.fire({
            icon: 'warning',
            title: 'Excluir serviço',
            confirmButtonText: 'Confirmar',
            showCancelButton: true,
            cancelButtonText: 'Cancelar'

         }).then((result) => {
            if (result.isConfirmed) {
               ref.$store.dispatch('alternarTelaCarregamento', true)
               
               ref.$axios({
                  method: 'post',
                  url: ref.urlRest +'servicos/deleteServico',
                  params:{
                     id: id
                  }
               }).then(function () {
                  ref.$refs.servico.style.display = 'none'

                  ref.$toast.fire({
                     icon: 'success',
                     title: 'Serviço excluído!'
                  })
               }).catch(function (error) {
                  if (error.response != undefined) {
                     if (error.response.status == 408) {
                        ref.$store.dispatch('deslogar')

                        ref.$toast.fire({
                           icon: 'warning',
                           title: 'Sessão expirada!'
                        });
                     } else {
                        ref.$toast.fire({
                           icon: 'error',
                           title: 'Erro: ' + error.response.status
                        })
                     }
                  } else {
                     ref.$toast.fire({
                        icon: 'error',
                        title: error
                     })
                  }
               }).finally(() => {
                  ref.$store.dispatch('alternarTelaCarregamento', false)
               })
            }
         });
      }
   }
}

</script>

<style scoped>
.text-start {
   text-align: start !important;
}
</style>
